import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "components/menu";
import config from "./config";

class HealthDiary extends Component {
  render() {
    return <Menu {...config} {...this.props} />;
  }
}

const mapStateToProps = (state) => {
  return {
    messages: state.intl.messages.containers.features.healthDiary,
    healthDiary: state.reducers.healthDiary,
    temperature: state.reducers.temperature,
  };
};

export default connect(mapStateToProps)(HealthDiary);
